import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class LegendService {

	constructor(
		private readonly http: HttpClient
	) {}

	getLegends(): Observable<string[]> {
		return this.http.get<string[]>(`${environment.backendUrl}/legend`);
	}
}
